import React from "react";
// import "./MetricsCard.css";

const MetricsCard = ({
  metricsData
}) => {
  return (
    <div className="metrics-card" style={{minHeight:"260px"}}>
      {/* <h4 className="card-title">User Engagement Metrics</h4> */}
      
      {metricsData?.map((rec, index) => (
      <div className="metric-row">
        <div className="metric-item">
          <div className="metric-info">
            <span className="metric-label">{rec.label}</span>
            <span className="metric-value">{rec?.value?.toLocaleString()}</span>
          </div>
          <div className="metric-bar-container">
            <div 
              className="metric-bar total-attempts" 
              style={{ width: `${Math.min(100, 56)}%` }}
              title={`${rec.value}`}
            ></div>
          </div>
        </div>
      </div>
      ))}
      
      {/* <div className="metric-grid">
        <div className="metric-item">
          <div className="metric-info">
            <span className="metric-label">Avg per User</span>
            <span className="metric-value">{avgAttemptsPerUser.toFixed(1)}</span>
          </div>
          <div className="metric-bar-container">
            <div 
              className="metric-bar avg-user" 
              style={{ width: `${Math.min(100, avgAttemptsPerUser * 10)}%` }}
              title={`${avgAttemptsPerUser.toFixed(1)} attempts per user`}
            ></div>
          </div>
        </div>
        
        <div className="metric-item">
          <div className="metric-info">
            <span className="metric-label">Avg Daily per User</span>
            <span className="metric-value">{avgDailyAttemptsPerUser.toFixed(1)}</span>
          </div>
          <div className="metric-bar-container">
            <div 
              className="metric-bar avg-daily" 
              style={{ width: `${Math.min(100, avgDailyAttemptsPerUser * 20)}%` }}
              title={`${avgDailyAttemptsPerUser.toFixed(1)} daily attempts per user`}
            ></div>
          </div>
        </div>
      </div>
      
      <div className="metric-row">
        <div className="metric-item">
          <div className="metric-info">
            <span className="metric-label">Quiz Completion Rate</span>
            <span className="metric-value">{quizCompletionRate}%</span>
          </div>
          <div className="progress-container">
            <div 
              className="progress-bar" 
              style={{ width: `${quizCompletionRate}%` }}
              title={`${quizCompletionRate}% of users completed quizzes`}
            ></div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default MetricsCard;